import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

import { Utils } from 'src/services/utils';

@Component({
    selector: 'rm-edit-batch-label',
    templateUrl: './edit-batch-label.component.html',
    styleUrls: ['./edit-batch-label.component.css']
})

export class EditBatchLabelComponent implements OnInit {
    selectedBatch: any;
    selected: any = null;
    batchLabelRec: any;
    currentOrgObj: any;
    grossValue: number = null;
    tareValue: number = null;
    netValue: number = null;
    isLabelAlsoInner: boolean = false;
    containerValue: number = null;
    totalNetWeight: number = 0;
    disableBtn: boolean = true;
    // replace mode: the label already exists on the ledger, so updating it means
    // voiding the old one and issuing a new one in its place
    isReplace: boolean = false;
    reason: string = '';

    constructor(
        private dialogRef: MatDialogRef<EditBatchLabelComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private utils: Utils,
    ) { }

    cancel() {
        this.dialogRef.close();
    }

    update() {
        if (!this.isValid) {
            return;
        }

        const gross = this.isNetWeightEntry ? this.computedGrossValue : Number(this.grossValue);

        this.batchLabelRec.grossweight = gross;
        this.batchLabelRec.tareweight = Number(this.tareValue);
        this.batchLabelRec.isAlsoInner = this.isLabelAlsoInner;
        this.batchLabelRec.container = this.containerValue;
        this.batchLabelRec.netweight = (gross - this.tareValue).toFixed(this.currentOrgObj.labelWeightDecimals ? this.currentOrgObj.labelWeightDecimals : 3);

        this.dialogRef.close({
            data: { ...this.batchLabelRec },
            reason: this.reason.trim()
        });
    }

    ngOnInit(): void {
        this.batchLabelRec = this.data.batchLabel;
        this.currentOrgObj = this.data.currentOrgObj;
        this.isReplace = this.data.isReplace === true;
        this.grossValue = this.batchLabelRec.grossweight;
        this.tareValue = this.batchLabelRec.tareweight;
        this.isLabelAlsoInner = this.batchLabelRec.isAlsoInner;
        this.containerValue = this.batchLabelRec.container;

        // the label stores gross and tare, so the net box has to be seeded from
        // their difference - at display precision, or it shows float noise
        if (this.isNetWeightEntry) {
            this.netValue = Number((this.grossValue - this.tareValue)
                .toFixed(this.currentOrgObj.labelWeightDecimals ? this.currentOrgObj.labelWeightDecimals : 3));
        }
    }

    /**
     * Some orgs work from the tare of the empty container and the net quantity
     * filled into it, so they enter those two and gross is the computed sum.
     */
    get isNetWeightEntry(): boolean {
        return !!(this.currentOrgObj && this.currentOrgObj.isNetWeightEntered);
    }

    /** live gross for the read only box; null until both operands are filled */
    get computedGrossValue(): number {
        return this.utils.grossFromTareAndNet(this.tareValue, this.netValue);
    }

    /**
     * Mirrors the weight rules the chaincode enforces, so an obviously invalid
     * label never costs a round trip. The chaincode remains authoritative.
     */
    get isValid(): boolean {
        const tare = Number(this.tareValue);

        if (this.tareValue === null || !isFinite(tare)) {
            return false;
        }

        if (this.isNetWeightEntry) {
            const net = Number(this.netValue);

            // validate what was actually typed - the gross box is derived and
            // the operator never fills it in this mode
            if (this.netValue === null || !isFinite(net) || net <= 0) {
                return false;
            }
        } else {
            const gross = Number(this.grossValue);

            if (this.grossValue === null || !isFinite(gross) || gross - tare <= 0) {
                return false;
            }
        }

        if (this.containerValue === null || String(this.containerValue).length === 0) {
            return false;
        }

        // a void with no stated reason leaves no audit trail worth having
        if (this.isReplace && this.reason.trim().length === 0) {
            return false;
        }

        return true;
    }

    selectBatch(e) {
        if (e) {
            this.disableBtn = false;
        }

    }

}
